/**
 * Workspace 注册的「适应当前页」执行器：支持瞬时 fit 与带 transform 过渡的 fit（与演示全屏一致）。
 */

export type FitCurrentPageOptions = {
  /** 为 true 时对 stage 的 pan/zoom 使用 CSS transition */
  animated?: boolean;
};

type FitCurrentPageRunner = (options: FitCurrentPageOptions) => void;

let fitCurrentPageRunner: FitCurrentPageRunner | null = null;

export function registerWorkspacePageFitRunner(runner: FitCurrentPageRunner | null): void {
  fitCurrentPageRunner = runner;
}

export function hasWorkspacePageFitRunner(): boolean {
  return fitCurrentPageRunner != null;
}

export function requestFitCurrentPage(options: FitCurrentPageOptions = {}): void {
  requestAnimationFrame(() => fitCurrentPageRunner?.(options));
}
